export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
export const DO_NOTHING = () => { };
export const isNullish = (data) => data === undefined || data === null;
export const toStringOrNull = (value) => (!isNullish(value) ? String(value) : null);
export const toNumStrOrNull = (value) => {
    if (isNullish(value) || value === '') {
        return null;
    }
    const number = Number(value);
    return Number.isNaN(number) ? String(value) : number;
};
export const pluckNotDeleted = (collection) => collection?.filter((row) => !row.isDeleted);
export const stopEventBubble = (event) => {
    event.preventDefault();
    event.stopPropagation();
};
export const stopPropagation = (event) => event.stopPropagation();
export const getCharactersFromRegex = (reg) => {
    const source = reg.source;
    const slicedSource = source.slice(1, source.length - 1);
    const filteredSource = slicedSource.split('').reduce((counter, char) => {
        if (!counter.includes(char))
            counter += char;
        return counter;
    }, '');
    return filteredSource.split('').join(' ');
};
export const getTs = (prefix) => {
    const ts = Date.now();
    return prefix ? `${prefix}-${ts}` : ts;
};
